import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { formatDateString } from '@doltech/utils/lib/date';
import * as React from 'react';

import { Layout, MainSection, SetupCard } from './SharedSetupCard';

interface RiddleSetupCardProps {
  data: any;
}

export const RiddleSetupCard = (props: RiddleSetupCardProps) => {
  const { data } = props;
  const { active, question, correctAnswer, lastModifiedAt } = data;
  return (
    <SetupCard bordered>
      <Layout>
        <MainSection>
          {active && (
            <Typography.Paragraph
              className="active-label"
              variant="semi-bold/12"
              color="green100"
              ellipsis={{ rows: 1 }}
            >
              Currently active
            </Typography.Paragraph>
          )}
          <div className="info-section">
            <Typography.Title
              level={3}
              variant="regular/16"
              ellipsis={{ rows: 2, tooltip: question }}
            >
              {question}
            </Typography.Title>
            <Typography.Paragraph
              variant="semi-bold/16"
              ellipsis={{ rows: 1, tooltip: correctAnswer }}
            >
              {correctAnswer}
            </Typography.Paragraph>

            <Typography.Paragraph variant="regular/14" color="gray100">
              Last modified: {formatDateString(lastModifiedAt)}
            </Typography.Paragraph>
          </div>
        </MainSection>
      </Layout>
    </SetupCard>
  );
};
